export type UserRole = "student" | "educator" | "admin";

const studentAliases = new Set(["student", "user", "learner"]);
const educatorAliases = new Set(["educator", "teacher", "instructor"]);
const adminAliases = new Set(["admin", "administrator", "owner", "manager"]);

export function normalizeRole(
  rawRole?: string | null,
): UserRole | undefined {
  if (!rawRole) {
    return undefined;
  }

  const normalized = rawRole.toString().trim().toLowerCase();

  if (studentAliases.has(normalized)) {
    return "student";
  }

  if (educatorAliases.has(normalized)) {
    return "educator";
  }

  if (adminAliases.has(normalized)) {
    return "admin";
  }

  return undefined;
}
